// extracted by mini-css-extract-plugin
export default {"Vendita":"Vendita_Vendita__x-4XQ","ImmagineVendita":"Vendita_ImmagineVendita__fXX++","PrezziVendita":"Vendita_PrezziVendita__7fG9y"};